module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    class: _vm.className
  }, [_c('div', {
    staticClass: "stat-view"
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.stat)
    }
  }), _vm._v(" "), _c('figcaption', {
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0bedac22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiStat.vue
// module id = 58
// module chunks = 0